import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { useSessions } from '@/hooks/useSwr';

import { OnboardingStepV2 } from '../constants';

export const useRedirectExistingUser = ({
  skipRedirect,
  newTenantId,
  step,
}: {
  skipRedirect: boolean;
  newTenantId: string | undefined;
  step: OnboardingStepV2;
}) => {
  const navigate = useNavigate();
  const [_, setSearchParams] = useSearchParams();

  const sessions = useSessions({
    include_stats: false,
  });
  const existingSessionId = sessions.data?.rows?.filter(
    (s) => s.name !== 'default'
  )?.[0]?.id;

  useEffect(() => {
    if (skipRedirect) return;
    // don't let the user go back to either of the questionnaire pages
    if (newTenantId && step < OnboardingStepV2.Options) {
      setSearchParams({
        organizationId: newTenantId,
        step: OnboardingStepV2.Options.toString(),
      });
    }
  }, [
    existingSessionId,
    newTenantId,
    navigate,
    setSearchParams,
    step,
    skipRedirect,
  ]);
};
